<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryLiftCheckResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      with-custom-row-actions-first-column
                                      withCustomRowActions>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            custom-icon="fa fa-fw fa-lg fa-link"
                                            custom-label="查看吊具"
                                            @click="popSpa(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <sub-entity-list ref="spaEntityList" sub-entity="sithMesInventoryLiftRiggings"
                     parent-field="checkRecordId"></sub-entity-list>
    </div>
</template>
<script>
    // Author Lin
    // Date 2022-07-20 09:50:21

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import subEntityList from "@/components/em/EmModal/SubEntityList";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "sithMesInventoryLiftCheckListView",
        mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin],
        components: {subEntityList},
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            popSpa(row) {
                this.$refs.spaEntityList.showModal(row.id);
            },
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryLiftRiggings"
                    , {checkRecordIdFilter: row.id}
                    , {checkRecordId: row.id}, false, {})
            },
        },
        mounted() {
            if (this.$route.query.hasOwnProperty('checkId')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.checkId);
                this.$refs.emListFilter.doQuery();
            }
        },
    };
</script>